import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from '@repo/ui/components/select'
import { FormControl } from "@repo/ui/components/form";

import { cn } from '@repo/ui/lib/utils';
import { LoaderIcon } from '@repo/ui/components/icon';
interface SelectDropdownProps {
  onValueChange?: (value: string) => void;
  defaultValue?: string | undefined;
  placeholder?: string;
  isPending?: boolean;
  items: { label: string; value: string }[] | undefined;
  disabled?: boolean;
  className?: string;
  isControlled?: boolean;
  label?:string
}
function SelectDropdown({
  defaultValue,
  onValueChange,
  isPending,
  items,
  placeholder,
  disabled,
  className = "",
  label ='Loại BĐS',
  isControlled = false,
}: SelectDropdownProps) {
  const defaultState = isControlled
    ? { value: defaultValue, onValueChange }
    : { defaultValue, onValueChange };
  return (
    <Select {...defaultState}>
      <FormControl>
        <SelectTrigger
          disabled={disabled}
          size="lg"
          className={cn("bg-white w-full", className)}
        >
          <div className=" flex flex-col py-2 text-left">
            <div className=" font-normal text-gray-500 group-disabled/trigger:text-om-ink-300s text-xs">
              {label}
            </div>
            <SelectValue
              className="text-base text-left"
              placeholder={placeholder ?? "Vui lòng chọn"}
            />
          </div>
        </SelectTrigger>
      </FormControl>

      <SelectContent className="border-0">
        {isPending ? (
          <SelectItem disabled value="loading" className="h-14">
            <div className="flex items-center justify-center gap-2">
              <LoaderIcon className="h-5 w-5 animate-spin" />
              Loading...
            </div>
          </SelectItem>
        ) : (
          items?.map(({ label, value }) => (
            <SelectItem
              key={value}
              value={value}
              className="data-[state=checked]:bg-brand-50 data-[state=checked]:[&_svg]:text-brand-500"
            >
              {label}
            </SelectItem>
          ))
        )}
      </SelectContent>
    </Select>
  );
}

export default SelectDropdown;
